import { apiClient } from './client';
import type { TagList } from '../types';

export const tagsApi = {
  list: () => apiClient.get<TagList>('/tags'),
  deleteTag: (tagId: string) =>
    apiClient.delete<{ deleted: boolean; tag_id: string }>(`/tags/${tagId}`),
};
